import { cacheActions, sitesMobileData } from '@redux/slices/cache/cache-slice';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';

const siteJsonManipulationJson = ({ initialLogin, data, isSettingUpdated }) => {
  const { items = [] } = data;

  const { cache } = store.getState();
  //   const { sitesMap = {}, sites = [] } = cache;

  let resSite = [];
  if (!initialLogin && cache?.sites?.length && !isSettingUpdated) {
    if (items?.length) {
      const combineNewAndOldArray = checkOldAndNewArray({
        oldArray: cache?.sites || [],
        oldArrayMap: cache?.sitesMap || {},
        newArray: items,
        idName: 'siteId'
      });
      resSite = combineNewAndOldArray;
    } else {
      resSite = cache?.sites;
    }
  } else {
    if (items?.length) resSite = items;
  }

  const { sites, sitesMap } = sitesMobileData(resSite || [], cache);

  return {
    sites,
    sitesMap
  };
};

const sitesDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(cacheActions.setSitesMobile1(data));
};

export { siteJsonManipulationJson, sitesDispatcher };
